import React from "react";
import ToolBar from "../../../components/toolbar/ToolBar";
import url from '../../../url'
import Select from "react-select";
import axios from "axios";
import { getFDate } from "../../../util/date";
import { store } from 'react-notifications-component';
import Loading from "../../../components/loading/Loading";
import ModernAlert from "../../../components/alert/ModernAlert";
import './justify-journey.css';
import { Table, Button } from "reactstrap";
import TollTipChildren from "../../../components/tolltip-children/TollTipChildren";



class JustifyJourney extends React.Component {
    columns = [
        "Nome / Motorista",
        "Inicio",
        "Fim",
        "Justificativa",
        ""
    ]

    constructor(props) {
        super(props)

        this.state = {
            drivers: { options: [], loading: false },
            licenseNumbers: { options: [], loadingD: false },
            table: [],
            alert: { msg: 'Selecione data de inicio e fim e filtre.', type: '' },
            loading: false,
            deleteJustify: false,
            filter: {
                startPeriod: "",
                endPeriod: "",
                idDrivers: [],
            }
        }
    }




    componentDidMount() {
        this.getJustify()
    }

    getJustify = data => {
        this.setState({ loading: true, table: [], deleteJustify: false, alert: { msg: '', type: '' } });
        axios({
            method: !data || !data.startPeriod ? 'get' : 'post',
            url: `${url}/v1/telemetria/admin/journey/justification/${this.props.token}`,
            data
        }).then(d => {
            var msg = !d.data.length ? 'Não encontramos dados para os filtros selecionados.' : ''
            console.log(d)
            this.setState({
                loading: false,
                table: d.data,
                // filter: d.data.reportFilter,
                alert: { msg, type: '' }
            })
        }).catch(e => {
            console.log(e.response)
            var errorMsg = e.response.data.errorMessage
            this.setState({ loading: false })
            errorMsg.forEach(d => {
                if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
            })
        })
    };

    exportJourney = body => {
        this.setState({ loading: true });
        console.log(body)
        axios
            .request({
                url: `${url}/v1/telemetria/admin/journey/export/byGeneral/${this.props.token}`,
                method: "POST",
                responseType: "blob", //important
                data: {
                    ...body,
                    responseType: "blob"
                }
            })
            .then((data) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([data.data]));
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute(
                    "download",
                    `general_journey_${body.startPeriod}_${body.endPeriod}.xlsx`
                ); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.setState({ loading: false });
                console.log(data)
            })
            .catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    };

    downloadRep = body => {
        this.setState({ loading: true });

        axios
            .request({
                url: `${url}/v1/telemetria/admin/journey/rep/${this.props.token}`,
                method: "POST",
                responseType: "blob", //important
                data: {
                    ...body,
                    responseType: "blob"
                }
            })
            .then((data) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([data.data]));
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute(
                    "download",
                    `rep_${body.startPeriod}_${body.endPeriod}.txt`
                ); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.setState({ loading: false });
                // console.log(data.headers)
            })
            .catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    };


    renderToolbar = () => {
        return (
            <ToolBar>
                <div>
                    <label htmlFor="start-date" className='toolbar-label'>Inicio</label>
                    <input
                        id='start-date'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, startPeriod: i.target.value } })}
                        disabled={this.state.loading}
                        placeholder='Inicio'
                        max={getFDate()}
                        value={this.state.filter.startPeriod} />
                </div>

                <div>

                    <label htmlFor="end-period" className='toolbar-label'>Fim</label>
                    <input
                        id='end-period'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, endPeriod: i.target.value } })}
                        disabled={this.state.loading || !this.state.filter.startPeriod}
                        min={this.state.filter.startPeriod}
                        max={getFDate()}
                        value={this.state.filter.endPeriod}
                    />
                </div>

                <div>
                    <label htmlFor="drivers" className='toolbar-label'>Motoristas</label>
                    {/* Select Motoristas */}
                    <Select
                        inputId='drivers'
                        isLoading={this.state.drivers.loading}
                        className='toolbar-select'
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Motoristas"
                        noOptionsMessage={e => { return !e.inputValue ? 'Pesquise os motoristas!' : `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.drivers.options}
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, idDrivers: [] } })
                            }
                            else {
                                let idDrivers = []
                                i.forEach(d => idDrivers.push(d.value))
                                this.setState({ filter: { ...this.state.filter, idDrivers } })
                            }
                        }}
                        onInputChange={(i) => {
                            if (i.length > 2) {
                                this.setState({ drivers: { ...this.state.drivers, loading: true } });
                                axios
                                    .get(`${url}/v1/telemetria/admin/cache/drivers/${encodeURI(i)}/${this.props.token}`)
                                    .then(d => {
                                        let options = [];
                                        d.data.forEach(d => options.push({ label: d.driverName, value: d.driverId }))
                                        this.setState({ drivers: { options, loading: false } });
                                    })
                                    .catch(e => console.log(e.response));
                            }
                        }}
                        isDisabled={this.state.loading}
                    />
                    <div className="toolbar-space" />
                </div>
                <input
                    type="button"
                    value='Filtrar'
                    className='telemetry-button toolbar-button toolbar-button-space'
                    onClick={() => this.getJustify(this.state.filter)}
                    disabled={!this.state.filter.startPeriod || !this.state.filter.endPeriod || this.state.loading}
                />

            </ToolBar>
        )
    }

    preDelete = data => {
        this.setState({ loading: true, deleteJustify: true })
        setTimeout(() => {
            this.setState({ loading: false, table: [data] })

        }, 200);
    }

    delete = answer => {
        if (answer) {
            this.setState({ loading: true })
            axios.delete(`${url}/v1/telemetria/admin/journey/justification/${this.state.table[0].justificationId}/${this.props.token}`)
                .then(d => {
                    console.log(d)
                    store.addNotification({ ...this.props.bodyNotify, title: 'Justificativa Apagada', type: 'danger' });
                    this.setState({ loading: false })

                    this.getJustify(this.state.filter)

                })
                .catch(e => {
                    var errorMsg = e.response.data.errorMessage
                    this.setState({ loading: false })
                    errorMsg.forEach(d => {
                        if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                        else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                    })
                    this.getJustify(this.state.filter)
                })
        } else {
            this.getJustify(this.state.filter)
        }
    }


    render() {
        return (
            <div>
                {this.renderToolbar()}

                {this.state.loading ? (
                    <div className='app-tool-center-loading '>
                        <Loading />
                    </div>
                ) : this.state.table.length ? (
                    <div style={{ marginRight: '5px' }}>

                        {this.state.deleteJustify ? (
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '20px' }}>
                                <p>Deseja Excluir a Jusitificativa?</p>
                                <div>
                                    <Button type="button" size="sm" color="secondary" style={{ marginRight: '10px' }} onClick={() => this.delete(true)}>SIM</Button>
                                    <Button type="button" size="sm" color="secondary" onClick={() => this.delete(false)}>NÃO</Button>
                                </div>
                            </div>
                        ) : null}

                        <Table responsive className="table-change-color standard-table">
                            <thead>
                                <tr>
                                    {this.columns.map((d, i) => {
                                        return (
                                            <th key={i} style={{width: '30%', minWidtn: '150px'}}>{d}</th>
                                        )
                                    })}
                                </tr>
                            </thead>
                            <tbody>

                                {this.state.table.map((d, i) => {
                                    return (
                                        <tr key={i} className='tr-table-pendencie tr-table-change-color'>
                                            <td className='td-table-journey-control' style={{width: '30%', minWidtn: '150px'}}>{d.driverName}</td>
                                            <td className='td-table-journey-control' style={{width: '30%', minWidtn: '150px'}}>{d.startDate}</td>
                                            <td className='td-table-journey-control' style={{width: '30%', minWidtn: '150px'}}>{d.endDate}</td>
                                            <td className='td-table-journey-control' style={{width: '30%', minWidtn: '150px'}}>{d.justification}</td>
                                            <td className='td-table-journey-control' style={{width: '30%', minWidtn: '150px'}}>
                                                {!this.state.deleteJustify ? (
                                                    <TollTipChildren text='Apagar Justificativa' id={`delete-justify-${i}`}>
                                                        <Button type="button" id={`delete-justify-${i}`} outline color="danger" onClick={() => this.preDelete(d)}><i className="fas fa-trash-alt" style={{ fontSize: '18px', marginTop: '2px' }}></i></Button>
                                                    </TollTipChildren>
                                                ) : null}
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                    </div>
                ) : null}
                <div style={{ width: '440px', marginTop: '20px', alignSelf: 'center' }}>
                    <ModernAlert msg={this.state.alert.msg} color={this.state.alert.type} />
                </div>
            </div>
        )
    }

}

export default JustifyJourney